import { Link, MenuItem } from '@mui/material';
import React from 'react';

import { useMenuContext } from '../../ContextState/useMenuContext';
import { DATA_TEST } from '../../enums';

import { OpenGovSVGIcon } from './OpenGovSVGIcon';

export const OpenGovIconMenuItem = () => {
  const { hideOpenGovLogo, openGovLogoUrl, openGovLogoOnClick, openGovLogoLinkComponent } = useMenuContext();
  const labelRef = React.useRef<HTMLAnchorElement>(null);
  const interactable = openGovLogoUrl || openGovLogoOnClick;

  if (hideOpenGovLogo) {
    return null;
  }

  const styles = {
    '&:hover': {
      cursor: interactable ? 'pointer' : 'default',
      backgroundColor: 'transparent'
    },
    '&:focus': {
      backgroundColor: 'transparent'
    },
    borderBottom: 'none',
    px: 1.5,
    py: 0.25
  };

  return (
    <MenuItem
      disableRipple={true}
      id="openGovLogo"
      aria-label="OpenGov Logo"
      data-test={DATA_TEST.opengov_logo}
      onKeyDown={(e) => {
        if ([' ', 'Enter'].includes(e.key)) {
          if (interactable) {
            e.preventDefault();
            if (openGovLogoUrl) {
              // If item has a URL, click inner Link component
              // (important for keyboard navigation & general accessibility)
              labelRef?.current?.click();
            } else {
              openGovLogoOnClick?.();
            }
          }
        }
      }}
      sx={styles}
      onClick={() => {
        if (openGovLogoOnClick) {
          openGovLogoOnClick();
        }
      }}
      tabIndex={interactable ? 0 : -1}
    >
      {openGovLogoUrl ? (
        <Link
          data-test={DATA_TEST.opengov_logo_link}
          href={openGovLogoUrl}
          component={openGovLogoLinkComponent || 'a'}
          noWrap={true}
          underline="none"
          tabIndex={-1}
          aria-label="OpenGov Logo Link"
          ref={labelRef}
          sx={{
            color: 'inherit',
            '&:visited': {
              color: 'inherit'
            }
          }}
        >
          <OpenGovSVGIcon />
        </Link>
      ) : (
        <OpenGovSVGIcon />
      )}
    </MenuItem>
  );
};
